// NGRX
import { createSelector } from '@ngrx/store';
// Lodash
import { each, find, some } from 'lodash';

export const selectAuthState = (state) => state.auth;

export const isAuthenticated = createSelector(
  selectAuthState,
  (auth) => auth.isAuthenticated,
);

export const isAdmin = createSelector(selectAuthState, (auth) => auth.isAdmin);

export const currentUser = createSelector(selectAuthState, (auth) => auth.user);

export const currentLogin = createSelector(selectAuthState, (auth) => auth.login);
